module.exports = __webpack_public_path__ + "static/media/Single Matting Text.04885b63.png";